import { http } from "../../services/app/app.service";

const UserService = {
    /**
     * Validate code in api call
     * @param {string} code - the code payload
     */
    validateCode: (code) => {
        return http
            .get(`cirightscan/m1528093/${code}`)
            .then((res) => res.data)
            .catch((error) => ({ error }));
    },

    /**
     * User Sign in
     * @param {object} signInData - the signin payload
     */
    signIn: (signInData) => {
        return http
            .post("/cirightscan/m1529260", signInData)
            .then((res) => res.data)
            .catch((error) => ({ error }));
    },

    /**
     * User Sign in
     * @param {object} signInData - the signin payload
     */
    signInWithSubscription: (signInData) => {
        return http
            .post("/cirightscan/m1529260", signInData)
            .then((res) => res.data)
            .catch((error) => ({ error }));
    },
};

export default UserService;
